module.exports = __webpack_public_path__ + "static/logo-white-3088d11eede673377688dcb0b8bfce4e.png";